// Run this Angular example by adding the following HTML markup to your view:
//
// <hello-angular>Loading...</hello-angular>
//
// <%= javascript_pack_tag 'product_search' %>

require('../product_search')



// WEBPACK FOOTER //
// ./app/javascript/packs/product_search.js